<template>
  <div class="paypal-return">
    <h1>Conferma pagamento PayPal</h1>

    <div v-if="loading" class="status">⏳ Conferma del pagamento in corso…</div>

    <div v-else-if="success" class="status success">
      ✅ Pagamento completato con successo! <br />
      {{ giftCredited ? "La gift è stata accreditata sul saldo del destinatario." : "L’ordine è stato aggiornato." }}
    </div>

    <div v-else class="status error">
      ❌ Errore nella conferma del pagamento: <br />
      <code>{{ error }}</code>
    </div>
  </div>
</template>

<script>
import { getPayPalFunctionUrl } from '@/lib/env';

export default {
  name: 'PayPalReturn',
  data() {
    return {
      loading: true,
      success: false,
      giftCredited: false,
      error: null,
    }
  },
  methods: {
    // Legge parametri query in modo case-insensitive (utile per PayerID)
    getQueryInsensitive(name) {
      const q = this.$route?.query || {}
      if (q[name] != null) return q[name]
      const wanted = name.toLowerCase()
      const k = Object.keys(q).find(key => key.toLowerCase() === wanted)
      return k ? q[k] : null
    }
  },
  async mounted() {
    try {
      // ⚠️ Hash mode: usa Vue Router, non window.location.search
      const orderId = this.getQueryInsensitive('orderId')
      const token   = this.getQueryInsensitive('token')
      const payerId = this.getQueryInsensitive('PayerID') || this.getQueryInsensitive('payerId') || this.getQueryInsensitive('payerID')

      if (!orderId || !token || !payerId) {
        throw new Error(`Parametri mancanti: orderId=${orderId}, token=${token}, payerId=${payerId}`)
      }

      const fnUrl = getPayPalFunctionUrl('capture')

      if (!fnUrl) {
        throw new Error('Endpoint capture PayPal non configurato')
      }

      const res = await fetch(fnUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // La CF usa solo orderId e token; passare payerId non fa danni
        body: JSON.stringify({ orderId, token, payerId }),
      })

      if (!res.ok) {
        const errTxt = await res.text().catch(() => '')
        throw new Error(`Errore HTTP ${res.status}: ${errTxt}`)
      }

      const payload = await res.json()
      // payload = { success: true, data: { status: 'COMPLETED', ... } }
      const completed =
        (payload && payload.success === true) ||
        (payload && payload.data && payload.data.status === 'COMPLETED')

      if (completed) {
        this.giftCredited = payload?.credit?.credited === true
        this.success = true
        const next = this.getQueryInsensitive('next')
        if (next && String(next).startsWith('/checkout/')) {
          setTimeout(() => {
            this.$router.replace(String(next))
          }, 900)
        }
      } else {
        throw new Error('Risposta inattesa: ' + JSON.stringify(payload))
      }
    } catch (err) {
      this.error = err?.message || String(err)
    } finally {
      this.loading = false
    }
  },
}
</script>

<style scoped>
.paypal-return {
  max-width: 600px;
  margin: 4rem auto;
  padding: 2rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  text-align: center;
  font-family: sans-serif;
}
.status { margin-top: 1rem; font-size: 1.1rem; }
.success { color: green; font-weight: bold; }
.error { color: red; font-weight: bold; }
</style>
